module.exports = __webpack_public_path__ + "img/ic_linkedin.542a58c5.svg";